/* Lagom theme: user-cards module, ported from the prototype's main.js. Loads when a section with cards is on the page
   (User cards, Rating and quotes); every .scards carousel on the page gets its own phone deck and desktop slider. */
(function () {
  'use strict';
  var L = window.Lagom; if (!L || !L.q || L.cardsLoaded) { return; }
  L.cardsLoaded = true;   /* two sections may include this script: it runs once and sets up every carousel */
  var q = L.q, qa = L.qa, motionOff = L.motionOff, MOTION = L.MOTION, CAPTURE = L.CAPTURE, IMG = L.assetBase || '';

  /* ---------- Judge.me reviews ----------
     Every unique 5-star review of the product (Judge.me's public widget feed, 30 per page) becomes a card after the
     hand-made ones: text only, or with the review's first photo. Duplicate texts appear once (the copy with a real
     name wins), texts already on a hand-made card are skipped, and so is repeated-word spam. Cached in
     sessionStorage for an hour. Translations (assets/reviews-i18n.json: { normalised original text: { sv, en, … } })
     show each review in the visitor's language; a review without one keeps its own words. The carousels below start
     once the cards are in (or after 3 s without them). */
  var norm = function (t) { return String(t).toLowerCase().replace(/[^a-z0-9åäöæøü]+/g, ''); };
  function loadTranslations(wrap) {
    var url = wrap.getAttribute('data-jdgm-i18n');
    if (!url || !window.fetch) { return Promise.resolve({}); }
    return fetch(url).then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; });
  }
  function visitorLang() {
    var l = ((L.config && L.config.locale) || document.documentElement.lang || 'en').toLowerCase().slice(0, 2);
    return l === 'nb' || l === 'nn' ? 'no' : l;
  }
  function loadReviews(wrap) {
    var shop = wrap.getAttribute('data-jdgm-shop'), pid = wrap.getAttribute('data-jdgm-product');
    if (!shop || !pid || !window.fetch) { return Promise.resolve([]); }
    var KEY = 'lagom_reviews_' + pid, base = 'https://judge.me/reviews/reviews_for_widget?url=' + encodeURIComponent(shop) +
      '&shop_domain=' + encodeURIComponent(shop) + '&platform=shopify&per_page=30&product_id=' + encodeURIComponent(pid) + '&page=';
    try { var c = JSON.parse(sessionStorage.getItem(KEY) || 'null'); if (c && Date.now() - c.t < 36e5) { return Promise.resolve(c.r); } } catch (e) { /* no cache */ }
    var page = function (n) { return fetch(base + n).then(function (r) { if (!r.ok) { throw new Error(r.status); } return r.json(); }); };
    return page(1).then(function (first) {
      var pages = Math.min(10, (first.pagination && first.pagination.total_pages) || 1), rest = [];
      for (var n = 2; n <= pages; n++) { rest.push(page(n).catch(function () { return { reviews: [] }; })); }
      return Promise.all(rest).then(function (more) {
        var all = (first.reviews || []).concat.apply(first.reviews || [], more.map(function (m) { return m.reviews || []; }));
        var out = all.filter(function (r) { return Number(r.rating) === 5; }).map(function (r) {
          var div = document.createElement('div'); div.innerHTML = r.body_html || ''; var text = (r.body || div.textContent || '').replace(/\s+/g, ' ').trim();
          var pic = r.pictures_urls && r.pictures_urls[0] ? (r.pictures_urls[0].huge || r.pictures_urls[0].original) : '';
          return { text: text, name: r.reviewer_name || '', pic: pic };
        });
        try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), r: out })); } catch (e) { /* this visit only */ }
        return out;
      });
    });
  }
  function addReviewCards(wrap, list, tr) {
    var lang = visitorLang();
    /* The hand-made cards of other sections on the page (Rating and quotes) come first in this wall too. */
    qa('.scards').forEach(function (other) {
      if (other === wrap) { return; }
      qa('.scard', other).forEach(function (c) {
        if (c.classList.contains('is-clone')) { return; }
        var k = c.cloneNode(true); k.removeAttribute('data-shopify-editor-block'); k.classList.add('scard--copy'); wrap.appendChild(k);
      });
    });
    var anon = function (n) { return !n || /^(anonymous|shopper|anonym)$/i.test(n.trim()); };
    var spam = function (t) { var w = t.toLowerCase().split(/\s+/); return w.length >= 4 && new Set(w).size <= w.length / 3; };
    var seen = {};
    qa('.scard__quote').forEach(function (el) { seen[norm(el.textContent)] = true; });   /* hand-made cards anywhere on the page */
    var best = {};
    list.forEach(function (r) {
      var k = norm(r.text); if (!k || seen[k] || spam(r.text)) { return; }
      if (!best[k]) { best[k] = r; return; }
      if (anon(best[k].name) && !anon(r.name)) { best[k] = { text: best[k].text, name: r.name, pic: best[k].pic || r.pic }; }
      else if (!best[k].pic && r.pic) { best[k].pic = r.pic; }
    });
    var esc = function (t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; };
    var stars = wrap.getAttribute('data-jdgm-stars') || '';
    Object.keys(best).forEach(function (k) {
      var r = best[k], f = document.createElement('figure'), text = (tr && tr[k] && tr[k][lang]) || r.text;
      f.className = 'scard scard--review' + (r.pic ? '' : ' scard--text') + (text.length < 70 ? ' scard--short' : '');
      f.innerHTML = (r.pic ? '<img class="scard__img" src="' + esc(r.pic) + '" width="1024" height="768" alt="" loading="lazy" decoding="async">' : '') +
        '<figcaption class="scard__body"><span class="scard__stars" aria-label="' + esc(stars) + '">★★★★★</span>' +
        '<blockquote class="scard__quote"><p>' + esc(text) + '</p></blockquote>' +
        (anon(r.name) ? '' : '<span class="scard__by">' + esc(r.name.split(' ')[0]) + '</span>') + '</figcaption>';
      wrap.appendChild(f);
    });
  }

  function boot() {
  /* ---------- Brick wall (data-bricks) ----------
     The cards as a wall of bricks: rows of k cards and k-1 cards by turns, centred, so every other row sits half a
     card over (k = 4 from 1024px, 3 from 768px, 2 on phones). All cards get the height of the tallest. When the wall
     comes on screen the cards drop into place one by one, like bricks being laid; "Show more" lays two more rows the
     same way. Motion off: no animation. */
  /* From 768px a [data-glide] slider (Rating and quotes) uses the drift engine below without the drift: no motion of
     its own, arrows, swipe/drag/trackpad with inertia, then it settles softly with a card in the middle. No native
     scroll, so no jump at the loop point. Phones keep the stacked deck. */
  if (window.innerWidth >= 768) {
    qa('.scards[data-glide]').forEach(function (w) { w.setAttribute('data-drift', '1'); w.setAttribute('data-speed', '0'); w.setAttribute('data-snap', ''); });
  }

  /* ---------- Drift (data-drift="rows") ----------
     An endless band of cards that drifts slowly to the left by itself (data-speed px/s). A swipe or a drag (or a
     sideways trackpad scroll) moves it faster; let go and it glides on, then eases back to the slow drift. It loops
     both ways without an edge: each row holds its cards, then copies of them until the band covers the screen twice,
     and the position wraps around one set. Moved with transform in one requestAnimationFrame loop (the compositor
     does the work, so it stays smooth), only while on screen. Hovering with a mouse slows it to a stop, to read.
     Up and down swipes are left to the page. data-compact: two rows of small landscape cards, the second half a card
     over like bricks. Motion off: no drift, dragging still works. */
  qa('.scards[data-drift]').forEach(function (wrap) {
    var cards = qa('.scard', wrap);
    if (!cards.length) { return; }
    var snap = wrap.hasAttribute('data-snap');
    var nav = wrap.parentNode.querySelector('.scards__nav'); if (nav && !snap) { nav.remove(); nav = null; }
    var rowsN = Math.max(1, parseInt(wrap.getAttribute('data-drift'), 10) || 1);
    var speed = wrap.hasAttribute('data-speed') ? (parseFloat(wrap.getAttribute('data-speed')) || 0) : 20;
    wrap.classList.add('is-drift');
    var holder = document.createElement('div'); holder.className = 'drift__rows';
    var rows = [];
    for (var r = 0; r < rowsN; r++) {
      var row = document.createElement('div'); row.className = 'drift__row';
      var track = document.createElement('div'); track.className = 'drift__track';
      cards.forEach(function (c, i) { if (i % rowsN === r) { track.appendChild(c); } });
      row.appendChild(track); holder.appendChild(row);
      rows.push({ track: track, originals: qa('.scard', track), setW: 0, shift: 0 });
    }
    wrap.textContent = ''; wrap.appendChild(holder);
    function gapOf(t) { return parseFloat(getComputedStyle(t).columnGap) || 0; }
    function layout() {
      var vw = wrap.clientWidth || window.innerWidth;
      rows.forEach(function (rw, ri) {
        qa('.is-clone', rw.track).forEach(function (k) { k.remove(); });
        var g = gapOf(rw.track), w = 0;
        rw.originals.forEach(function (c) { w += c.offsetWidth + g; });
        rw.setW = w || 1;
        var copies = Math.max(1, Math.ceil((vw * 2) / rw.setW) + 1);
        for (var k = 0; k < copies; k++) {
          rw.originals.forEach(function (c) {
            var cl = c.cloneNode(true); cl.classList.add('is-clone'); cl.setAttribute('aria-hidden', 'true');
            qa('button, a', cl).forEach(function (e) { e.setAttribute('tabindex', '-1'); });
            rw.track.appendChild(cl);
          });
        }
        rw.step = rw.originals[0] ? rw.originals[0].offsetWidth + g : 1;
        rw.shift = snap ? -(vw - (rw.step - g)) / 2 : ri % 2 ? rw.step / 2 : 0;   /* snap: a card in the middle; else bricks */
      });
      var all = qa('.scard', wrap);
      all.forEach(function (c) { c.style.height = ''; });
      var h = 0; cards.forEach(function (c) { h = Math.max(h, c.offsetHeight); });
      all.forEach(function (c) { c.style.height = h + 'px'; });
      paint();
    }
    var x = 0, vel = -speed, base = -speed, last = 0, raf = 0, onScreen = false, hover = false;
    var drag = null, moved = false, tween = null;
    if (motionOff()) { base = 0; vel = 0; }
    function step() { return rows[0].step || 1; }
    function tweenTo(target, dur, inOut) { tween = { from: x, to: target, t0: 0, dur: motionOff() ? 1 : dur, inOut: inOut }; vel = 0; run(); }
    if (nav) {
      nav.hidden = false;
      qa('.scards__arrow', nav).forEach(function (b) {
        b.addEventListener('click', function () {
          var from = tween ? tween.to : Math.round(x / step()) * step();
          tweenTo(from - Number(b.dataset.dir) * step(), 700, true);
        });
      });
    }
    function paint() {
      rows.forEach(function (rw) {
        var p = ((x - rw.shift) % rw.setW + rw.setW) % rw.setW - rw.setW;
        rw.track.style.transform = 'translate3d(' + p.toFixed(2) + 'px,0,0)';
      });
    }
    function frame(t) {
      raf = 0;
      var dt = last ? Math.min(0.05, (t - last) / 1000) : 0; last = t;
      var idle = false;
      if (tween) {
        if (!tween.t0) { tween.t0 = t; }
        var k = Math.min(1, (t - tween.t0) / tween.dur);
        var e = tween.inOut ? (k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2) : 1 - Math.pow(1 - k, 3);
        x = tween.from + (tween.to - tween.from) * e;
        if (k >= 1) { tween = null; idle = snap; }
      } else if (!drag) {
        var target = hover && !snap ? 0 : base;
        vel += (target - vel) * (1 - Math.exp(-dt * (Math.abs(vel) > Math.abs(base) * 2 ? (snap ? 3.2 : 1.6) : 3)));   /* glide, then settle */
        x += vel * dt;
        if (snap && Math.abs(vel) < 60) {   /* slow enough: settle on the nearest card */
          var near = Math.round(x / step()) * step();
          if (Math.abs(near - x) < 0.5) { x = near; vel = 0; idle = true; } else { tweenTo(near, 420, false); }
        }
      }
      paint();
      if (onScreen && !document.hidden && !idle) { raf = window.requestAnimationFrame(frame); }
    }
    function run() { if (!raf && onScreen && !document.hidden) { last = 0; raf = window.requestAnimationFrame(frame); } }
    wrap.addEventListener('pointerdown', function (e) {
      if (!e.isPrimary || (e.pointerType === 'mouse' && e.button !== 0)) { return; }
      drag = { id: e.pointerId, x: e.clientX, y: e.clientY, lx: e.clientX, lt: e.timeStamp, on: false, v: 0 };
      moved = false;
    });
    wrap.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) { return; }
      var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
      if (!drag.on) {
        if (Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) { drag = null; return; }   /* the page scrolls */
        if (Math.abs(dx) < 6) { return; }
        drag.on = true; moved = true; vel = 0; tween = null; wrap.classList.add('is-dragging');
        try { wrap.setPointerCapture(e.pointerId); } catch (err) {}
      }
      var step = e.clientX - drag.lx, dts = Math.max(1, e.timeStamp - drag.lt) / 1000;
      x += step; drag.v = drag.v * 0.6 + (step / dts) * 0.4; drag.lx = e.clientX; drag.lt = e.timeStamp;
      paint();
    });
    function end(e) {
      if (!drag || e.pointerId !== drag.id) { return; }
      if (drag.on) { vel = Math.max(-4000, Math.min(4000, drag.v)); tween = null; }
      drag = null; wrap.classList.remove('is-dragging'); run();
    }
    wrap.addEventListener('pointerup', end); wrap.addEventListener('pointercancel', end);
    wrap.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    wrap.addEventListener('touchmove', function (e) { if (drag && drag.on && e.cancelable) { e.preventDefault(); } }, { passive: false });
    wrap.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) { return; }
      e.preventDefault(); tween = null; x -= e.deltaX; vel = -e.deltaX * 30; paint(); run();
    }, { passive: false });
    wrap.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hover = true; } });
    wrap.addEventListener('pointerleave', function () { hover = false; });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { onScreen = es[0].isIntersecting; run(); }, { rootMargin: '100px 0px' }).observe(wrap);
    } else { onScreen = true; }
    document.addEventListener('visibilitychange', run);
    layout(); run();
    var lw = window.innerWidth;
    window.addEventListener('resize', function () { if (window.innerWidth !== lw) { lw = window.innerWidth; layout(); } });
    window.addEventListener('load', layout);
  });

  /* ---------- Glider (data-marquee) ----------
     The cards (small) in two rows that scroll sideways together, the second row half a card over, like bricks. No
     motion of its own: the arrows below scroll by a few cards (and fade out at either end); on phones a swipe works
     too. All cards share one height. */
  qa('.scards[data-marquee]').forEach(function (wrap) {
    var cards = qa('.scard', wrap);
    if (!cards.length) { return; }
    var nav = wrap.parentNode.querySelector('.scards__nav');
    wrap.classList.add('is-marquee');
    var inner = document.createElement('div'); inner.className = 'marquee__rows';
    [0, 1].forEach(function (r) {
      var row = document.createElement('div'); row.className = 'marquee__row' + (r ? ' is-offset' : '');
      cards.forEach(function (c, i) { if (i % 2 === r) { row.appendChild(c); } });
      inner.appendChild(row);
    });
    wrap.textContent = ''; wrap.appendChild(inner);
    function size() {
      cards.forEach(function (c) { c.style.height = ''; });
      var h = 0; cards.forEach(function (c) { h = Math.max(h, c.offsetHeight); });
      cards.forEach(function (c) { c.style.height = h + 'px'; });
      ends();
    }
    var btns = nav ? qa('.scards__arrow', nav) : [];
    function ends() {
      var max = wrap.scrollWidth - wrap.clientWidth - 2;
      btns.forEach(function (b) { b.disabled = Number(b.dataset.dir) < 0 ? wrap.scrollLeft <= 2 : wrap.scrollLeft >= max; });
    }
    if (nav) {
      nav.hidden = false; nav.classList.add('is-glider');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var step = (cards[0].offsetWidth + (parseFloat(getComputedStyle(cards[0].parentNode).columnGap) || 14)) * Math.max(1, Math.floor(wrap.clientWidth / cards[0].offsetWidth) - 1);
          wrap.scrollBy({ left: Number(b.dataset.dir) * step, behavior: motionOff() ? 'auto' : 'smooth' });
        });
      });
    }
    wrap.addEventListener('scroll', function () { window.requestAnimationFrame(ends); }, { passive: true });
    size();
    var lw = window.innerWidth;
    window.addEventListener('resize', function () { if (window.innerWidth !== lw) { lw = window.innerWidth; size(); } });
    window.addEventListener('load', size);
  });

  qa('.scards[data-bricks]').forEach(function (wrap) {
    var cards = qa('.scard', wrap), n = cards.length;
    if (!n) { return; }
    var more = wrap.parentNode.querySelector('[data-bricks-more]');
    var nav = wrap.parentNode.querySelector('.scards__nav'); if (nav) { nav.remove(); }
    var startRows = parseInt(wrap.getAttribute('data-bricks') || '3', 10) || 3;
    var k = 0, rows = 0, laid = 0, seen = false;
    wrap.classList.add('is-bricks');
    cards.forEach(function (c) { c.classList.add('brick'); });
    function perRow() { var w = window.innerWidth; return w >= 1024 ? 4 : w >= 768 ? 3 : 2; }
    function rowSize(r) { return Math.max(1, r % 2 ? k - 1 : k); }
    function count(r) { var t = 0; for (var i = 0; i < r; i++) { t += rowSize(i); } return Math.min(t, n); }
    function build(animateFrom) {
      wrap.textContent = '';
      var shown = count(rows), i = 0;
      for (var r = 0; i < shown; r++) {
        var row = document.createElement('div'); row.className = 'bricks__row';
        for (var j = 0; j < rowSize(r) && i < shown; j++, i++) { row.appendChild(cards[i]); }
        wrap.appendChild(row);
      }
      wrap.style.setProperty('--brick-k', String(k));
      cards.forEach(function (c) { c.style.height = ''; });
      var h = 0; for (var a = 0; a < shown; a++) { h = Math.max(h, cards[a].offsetHeight); }
      for (var b = 0; b < shown; b++) { cards[b].style.height = h + 'px'; }
      if (more) { more.hidden = shown >= n; }
      if (animateFrom != null) { lay(animateFrom, shown); }
      laid = Math.max(laid, shown);
    }
    function lay(from, to) {
      if (motionOff()) { for (var i = from; i < to; i++) { cards[i].classList.remove('is-waiting'); } return; }
      for (var j = from; j < to; j++) { cards[j].classList.add('is-waiting'); cards[j].style.transitionDelay = ''; }
      void wrap.offsetWidth;   /* start from the waiting state */
      for (var m = from; m < to; m++) { cards[m].style.transitionDelay = ((m - from) * 70) + 'ms'; cards[m].classList.remove('is-waiting'); }
    }
    function setup() {
      var nk = perRow(); if (nk === k) { return; }
      var shown = count(rows); k = nk; rows = startRows;
      while (count(rows) < Math.max(shown, 1) && count(rows) < n) { rows++; }
      build(null);
      if (!seen) { for (var i = 0; i < count(rows); i++) { cards[i].classList.add('is-waiting'); } }
    }
    setup();
    var go = function () { if (seen) { return; } seen = true; lay(0, count(rows)); };
    if ('IntersectionObserver' in window && !motionOff()) {
      var io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { io.disconnect(); go(); } }, { threshold: 0.15 });
      io.observe(wrap);
    } else { go(); }
    if (more) {
      more.addEventListener('click', function () {
        var from = count(rows); rows += 2; build(from);
      });
    }
    var lw = window.innerWidth;
    window.addEventListener('resize', function () { if (window.innerWidth !== lw) { lw = window.innerWidth; var keep = seen; setup(); if (keep) { cards.forEach(function (c) { c.classList.remove('is-waiting'); }); } } });
    window.addEventListener('load', function () { build(null); });   /* photos and fonts are in: measure the heights again */
  });

  /* ---------- 2p. Phones: user cards as an endless stacked carousel ----------
     One front card with the other two tucked behind it, one on each side (smaller, turned outward), like a wheel
     that never ends. The position `pos` is a float that grows or shrinks without limit; each card's offset is
     (index - pos) wrapped into -n/2..n/2, so card 3 always sits behind card 1 and the loop has no seam.
     Drag: the card follows the finger (the page still scrolls up and down: touch-action pan-y and an axis lock);
     on release it eases to the next card if the swipe went past 25% of a step or was a flick, else back.
     Tap a back card to bring it forward; dots below; every 5 s it turns by itself while on screen and untouched
     for 8 s. Phones only (desktop keeps the three-across grid). Motion off: no auto-turn, moves are instant. */
  qa('.scards').forEach(function (wrap) {
    if (wrap.hasAttribute('data-bricks') || wrap.hasAttribute('data-marquee') || wrap.hasAttribute('data-drift')) { return; }
    var cards = qa('.scard', wrap), n = cards.length;
    if (n < 2) { return; }
    var mq = window.matchMedia('(max-width: 767px)');
    var pos = 0, anim = 0, lastTouch = 0, visible = false, step = 100, cur = -1, drawQueued = false;
    var dots = document.createElement('div');
    dots.className = 'scards__dots'; dots.setAttribute('role', 'group'); dots.setAttribute('aria-label', 'Choose a review');
    var dotEls = cards.map(function (c, i) {
      var d = document.createElement('button');
      d.type = 'button'; d.className = 'scards__dot'; d.setAttribute('aria-label', 'Review ' + (i + 1));
      d.addEventListener('click', function () { lastTouch = Date.now(); to(pos + wrapD(i - pos), true); });
      dots.appendChild(d); return d;
    });
    wrap.parentNode.insertBefore(dots, wrap.nextSibling);
    function wrapD(d) { d = ((d % n) + n) % n; return d >= n / 2 ? d - n : d; }
    function render() {
      if (!mq.matches) { return; }
      var front = ((Math.round(pos) % n) + n) % n;
      cards.forEach(function (c, i) {
        var d = wrapD(i - pos), ad = Math.abs(d), a = Math.min(ad, 1);
        var e = a * (2 - a);   // ease-out: the back cards settle into place quickly
        var x = d * step, sc = 1 - 0.16 * e - (ad > 1 ? 0.06 * (ad - 1) : 0), ry = Math.max(-1, Math.min(1, d)) * 22;
        c.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0) perspective(1000px) rotateY(' + ry.toFixed(2) + 'deg) scale(' + sc.toFixed(4) + ')';
        c.style.opacity = ad <= 1 ? '1' : Math.max(0, 1 - (ad - 1) * 2).toFixed(3);
        c.style.zIndex = String(10 - Math.round(ad * 3));
      });
      /* Dots: the white pill stays in the centre; the dots slide past it with the cards (same pos, so they follow the
         finger and the turn animation) and loop round like the deck. Pill 22 px, dots 8 px, 8 px apart. */
      dotEls.forEach(function (dt, k) {
        var d = wrapD(k - pos), ad = Math.abs(d), a = 1 - Math.min(ad, 1);
        var x = (d < 0 ? -1 : 1) * (ad <= 1 ? 23 * ad : 23 + 16 * (ad - 1));
        dt.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0)';
        dt.style.opacity = ad <= 2 ? '1' : Math.max(0, 1 - (ad - 2) * 2).toFixed(3);
        dt.style.setProperty('--a', a.toFixed(3));
      });
      if (front !== cur) {
        cur = front;
        dotEls.forEach(function (d, k) { d.setAttribute('aria-pressed', k === cur ? 'true' : 'false'); });
        cards.forEach(function (c, k) { c.classList.toggle('is-active', k === cur); c.setAttribute('aria-hidden', k === cur ? 'false' : 'true'); });
      }
    }
    /* soft = the slow, gentle turn (auto-turn, dots); otherwise (a released swipe, a tap) it carries straight on from
       where the finger left it and slows down: ease-out, about half a second. */
    function to(target, soft) {
      window.cancelAnimationFrame(anim);
      var from = pos, t0 = performance.now(), dist = Math.abs(target - from);
      var dur = motionOff() ? 0 : soft ? 900 : 380 + 220 * Math.min(1, dist);
      if (!dur) { pos = target; render(); return; }
      (function f(now) {
        var k = Math.min(1, (now - t0) / dur);
        var e = soft ? (k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2) : 1 - Math.pow(1 - k, 3);   // in-out when soft, else ease-out
        pos = from + (target - from) * e; render();
        if (k < 1) { anim = window.requestAnimationFrame(f); }
      })(t0);
    }
    function layout() {
      if (!mq.matches) {
        wrap.style.height = '';
        cards.forEach(function (c) { c.style.transform = c.style.opacity = c.style.zIndex = c.style.height = c.style.background = ''; c.classList.remove('is-active'); c.removeAttribute('aria-hidden'); });
        cur = -1; return;
      }
      cards.forEach(function (c) { c.style.height = ''; });
      var h = 0;
      cards.forEach(function (c) { h = Math.max(h, c.offsetHeight); });
      cards.forEach(function (c) { c.style.height = h + 'px'; });
      wrap.style.height = h + 'px';
      step = cards[0].offsetWidth * 0.36;
      cur = -1; render();
    }
    /* Drag with an axis lock: horizontal moves turn the wheel, vertical ones are left to the page. */
    var drag = null;
    wrap.addEventListener('pointerdown', function (ev) {
      if (!mq.matches || (ev.pointerType === 'mouse' && ev.button !== 0)) { return; }
      if (!ev.isPrimary || (window.Lagom && Lagom.zoomed && Lagom.zoomed())) {   /* a second finger (pinch) or zoomed in: the browser's, not a card swipe */
        if (drag) { var d0 = drag; drag = null; wrap.classList.remove('is-dragging'); try { wrap.releasePointerCapture(d0.id); } catch (e) {} to(Math.round(pos)); }
        return;
      }
      lastTouch = Date.now();
      window.cancelAnimationFrame(anim);
      drag = { id: ev.pointerId, x: ev.clientX, y: ev.clientY, p0: pos, on: false, pts: [[ev.timeStamp, ev.clientX]], el: ev.target };
    });
    wrap.addEventListener('pointermove', function (ev) {
      if (!drag || ev.pointerId !== drag.id) { return; }
      var dx = ev.clientX - drag.x, dy = ev.clientY - drag.y;
      if (!drag.on) {
        if (Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) { drag = null; to(Math.round(pos)); return; }
        if (Math.abs(dx) < 6) { return; }
        drag.on = true; wrap.classList.add('is-dragging');
        try { wrap.setPointerCapture(ev.pointerId); } catch (e) {}
      }
      drag.pts.push([ev.timeStamp, ev.clientX]); if (drag.pts.length > 6) { drag.pts.shift(); }
      pos = drag.p0 - dx / (step * 2.2);   // a full card's turn = a ~60% screen-wide swipe
      if (!drawQueued) { drawQueued = true; window.requestAnimationFrame(function () { drawQueued = false; render(); }); }   /* once per frame */
    });
    /* Pointer events cannot cancel the browser's own swipe gesture; the matching touchmove can (in-app browsers read
       a horizontal swipe as "back" / "close" otherwise). */
    wrap.addEventListener('touchmove', function (e) { if (drag && drag.on && e.touches.length < 2 && e.cancelable) { e.preventDefault(); } }, { passive: false });   /* two fingers = pinch zoom stays the browser's */
    function end(ev) {
      if (!drag || ev.pointerId !== drag.id) { return; }
      var d = drag; drag = null; lastTouch = Date.now(); wrap.classList.remove('is-dragging');
      if (!d.on) {
        if (ev.type === 'pointerup') {   // a tap: bring a back card forward
          var c = d.el.closest && d.el.closest('.scard'), i = cards.indexOf(c);
          if (i >= 0 && i !== cur) { to(pos + wrapD(i - pos)); return; }
        }
        to(Math.round(pos)); return;
      }
      var a = d.pts[0], b = d.pts[d.pts.length - 1], v = (b[1] - a[1]) / Math.max(1, b[0] - a[0]);   // px per ms
      var moved = pos - d.p0, base = Math.round(d.p0), target;
      if (Math.abs(v) > 0.35) { target = base + (v < 0 ? 1 : -1); }
      else if (Math.abs(moved) > 0.25) { target = base + (moved > 0 ? 1 : -1); }
      else { target = base; }
      to(target);
    }
    wrap.addEventListener('pointerup', end);
    wrap.addEventListener('pointercancel', end);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }, { threshold: 0.4 }).observe(wrap);
    } else { visible = true; }
    if (!motionOff()) {
      window.setInterval(function () {
        if (mq.matches && visible && !drag && !document.hidden && Date.now() - lastTouch > 8000) { to(Math.round(pos) + 1, true); }
      }, 5000);
    }
    mq.addEventListener('change', layout);
    window.addEventListener('load', layout);
    var lw = 0;
    window.addEventListener('resize', function () { if (window.innerWidth !== lw) { lw = window.innerWidth; layout(); } });
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(layout); }
    lw = window.innerWidth; layout();
  });

  /* ---------- 768px and up: an endless sideways slider ----------
     Native scrolling does the moving (compositor). The cards are copied once before and once after (inert,
     hidden on phones). Cards snap to the middle of the screen; when a scroll comes to rest on a copy, scrollLeft jumps by one set width to the same
     card in the real set, so it never reaches an end. The arrows scroll by one card. */
  qa('.scards').forEach(function (wrap) {
    if (wrap.hasAttribute('data-bricks') || wrap.hasAttribute('data-marquee') || wrap.hasAttribute('data-drift')) { return; }
    var nav = wrap.parentNode.querySelector('.scards__nav');
    if (!nav) { return; }
    var real = qa('.scard', wrap), n = real.length;
    if (n < 2) { return; }
    function copy(c) {
      var k = c.cloneNode(true);
      k.classList.add('is-clone'); k.setAttribute('aria-hidden', 'true');
      qa('button, a', k).forEach(function (e) { e.setAttribute('tabindex', '-1'); });
      k.removeAttribute('data-shopify-editor-block');
      return k;
    }
    real.forEach(function (c) { wrap.appendChild(copy(c)); });
    real.slice().reverse().forEach(function (c) { wrap.insertBefore(copy(c), wrap.firstChild); });
    var mq = window.matchMedia('(min-width: 768px)'), btns = qa('.scards__arrow', nav), idle = 0, setW = 0;
    var x0 = 0;   // the scroll position that puts the first real card in the middle of the screen
    function measure() {
      setW = real[0].offsetLeft - wrap.firstElementChild.offsetLeft;
      var r = real[0].getBoundingClientRect(), w = wrap.getBoundingClientRect();
      x0 = wrap.scrollLeft + (r.left + r.width / 2) - (w.left + wrap.clientWidth / 2);
      nav.hidden = !mq.matches;
    }
    function settle() {
      idle = 0;
      if (!mq.matches || !setW) { return; }
      var x = wrap.scrollLeft, half = real[0].offsetWidth / 2;
      if (x < x0 - half) { wrap.scrollLeft = x + setW; }
      else if (x >= x0 + setW - half) { wrap.scrollLeft = x - setW; }
    }
    function home() { measure(); if (mq.matches) { wrap.scrollLeft = x0; } }
    /* Arrows: glide one card over 800 ms (cubic ease-in-out), with snapping off meanwhile so it never jumps. */
    var gliding = 0;
    function glide(dx) {
      if (motionOff()) { wrap.scrollLeft += dx; settle(); return; }
      window.cancelAnimationFrame(gliding);
      var from = wrap.scrollLeft, t0 = performance.now(), dur = 800;
      wrap.style.scrollSnapType = 'none';
      (function f(now) {
        var k = Math.min(1, (now - t0) / dur), e = k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
        wrap.scrollLeft = from + dx * e;
        if (k < 1) { gliding = window.requestAnimationFrame(f); } else { gliding = 0; wrap.style.scrollSnapType = ''; settle(); }
      })(t0);
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        if (gliding) { return; }
        settle();
        var gap = parseFloat(getComputedStyle(wrap).columnGap) || 0;
        glide(Number(b.dataset.dir) * (real[0].offsetWidth + gap));
      });
    });
    if ('onscrollend' in window) { wrap.addEventListener('scrollend', settle); }
    else { wrap.addEventListener('scroll', function () { window.clearTimeout(idle); idle = window.setTimeout(settle, 160); }, { passive: true }); }
    var lw = window.innerWidth;
    window.addEventListener('resize', function () { if (window.innerWidth !== lw) { lw = window.innerWidth; home(); } });
    mq.addEventListener('change', home); window.addEventListener('load', home);
    home();
  });

  /* ---------- Video cards ----------
     The file is not fetched until the card is near the screen (preload none, src set by an observer); it plays
     muted while on screen and pauses when it leaves, the tab hides, or (phone carousel) its card is not the front one.
     Always muted (no sound button). Motion off: no autoplay, the poster stays and a tap plays it. */
  (function () {
    var vids = qa('.scard__video video');
    if (!vids.length) { return; }
    var seen = new Map(), noInline = false;
    /* Never fullscreen: every inline flag, no controls, no picture-in-picture. A browser that opens a playing video
       fullscreen anyway (in-app browsers without inline playback) gets it closed at once, and from then on the
       videos there show their poster and play only when tapped. */
    vids.forEach(function (v) {
      v.muted = true; v.defaultMuted = true; v.playsInline = true; v.controls = false;
      v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', ''); v.setAttribute('muted', '');
      try { v.disablePictureInPicture = true; } catch (e) {}
      var out = function () {
        noInline = true;
        try { if (v.webkitExitFullscreen) { v.webkitExitFullscreen(); } } catch (e) {}
        try { if (document.fullscreenElement && document.exitFullscreen) { document.exitFullscreen(); } } catch (e) {}
        try { if (document.pictureInPictureElement && document.exitPictureInPicture) { document.exitPictureInPicture(); } } catch (e) {}
        vids.forEach(function (o) { if (!o.paused) { o.pause(); } });
      };
      v.addEventListener('webkitbeginfullscreen', out);
      v.addEventListener('enterpictureinpicture', out);
      v.addEventListener('fullscreenchange', function () { if (document.fullscreenElement === v) { out(); } });
    });
    function front(v) { var c = v.closest('.scard'); if (c.classList.contains('is-clone')) { return true; } return !c.hasAttribute('aria-hidden') || c.getAttribute('aria-hidden') === 'false'; }
    function sync(v) {
      var want = seen.get(v) && !document.hidden && front(v) && ((!motionOff() && !noInline) || v.dataset.user === '1');
      if (want) {
        if (!v.src && v.dataset.src) { v.src = v.dataset.src; }
        var p = v.play(); if (p && p.catch) { p.catch(function () {}); }
      } else if (!v.paused) { v.pause(); }
    }
    function all() { vids.forEach(sync); }
    /* Judge.me videos: not every clip has every size; step down to the next one if a file is missing. */
    vids.forEach(function (v) {
      v.addEventListener('error', function () {
        var rest = (v.dataset.fallback || '').split(' ').filter(Boolean);
        if (!rest.length) { return; }
        v.dataset.src = rest.shift(); v.dataset.fallback = rest.join(' ');
        v.src = v.dataset.src; sync(v);
      });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { seen.set(e.target, e.isIntersecting); sync(e.target); }); }, { rootMargin: '200px 0px', threshold: 0.01 });
      vids.forEach(function (v) { io.observe(v); });
    } else { vids.forEach(function (v) { seen.set(v, true); }); all(); }
    document.addEventListener('visibilitychange', all);
    /* The carousel flips aria-hidden on the cards; follow it so only the front card plays. */
    if ('MutationObserver' in window) { qa('.scards').forEach(function (wrap) { new MutationObserver(all).observe(wrap, { attributes: true, subtree: true, attributeFilter: ['aria-hidden'] }); }); }
    vids.forEach(function (v) {
      var b = v.parentNode.querySelector('.scard__sound');
      if (motionOff()) { v.addEventListener('click', function () { v.dataset.user = '1'; sync(v); }); }
      if (!b) { return; }
      b.addEventListener('click', function (ev) {
        ev.stopPropagation();
        var on = v.muted;
        vids.forEach(function (o) { o.muted = true; var ob = o.parentNode.querySelector('.scard__sound'); if (ob) { ob.setAttribute('aria-pressed', 'false'); ob.setAttribute('aria-label', 'Sound on'); } });
        v.muted = !on; b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.setAttribute('aria-label', on ? 'Sound off' : 'Sound on');
        if (on) { v.dataset.user = '1'; sync(v); }
      });
    });
  })();

  }

  var started = false;
  function start() { if (!started) { started = true; boot(); } }
  var cardsWrap = q('.scards[data-jdgm-product]');   /* the carousel that adds Judge.me reviews (User cards), if any */
  if (cardsWrap) {
    window.setTimeout(start, 3000);
    Promise.all([loadReviews(cardsWrap), loadTranslations(cardsWrap)])
      .then(function (res) { if (!started) { addReviewCards(cardsWrap, res[0], res[1]); } start(); }, start);
  } else { start(); }
})();
